import axios from 'axios';

export default {
    async wishlistSearch(term) {
        let response = await axios.post('/api/wishlists/amazonProducts/search', { term });
        return response.data;
    },
}
